// extracted by mini-css-extract-plugin
module.exports = {"container":"Weekdays_container__2_Sww","day":"Weekdays_day__3KSHx"};